/* Generated by scripts/prepare-content.ts. Do not edit directly. */
import type { ComponentType } from "react";
import type { MDXProps } from "mdx/types";
import type { ArticleAssetRegistry, ArticleRenderContext } from "@th-m/blogs/mdx";

import ConspiracyByCategoriesContent from "./conspiracy-by-categories/article.mdx";
import ConspiracyByCategoriesAssets from "./conspiracy-by-categories/article-assets";
import "./conspiracy-by-categories/conspiracy-entry.css";
import AiConsciousnessIsIncoherentContent from "./ai-consciousness-is-incoherent/article.mdx";
import AiConsciousnessIsIncoherentAssets from "./ai-consciousness-is-incoherent/article-assets";
import AiConsciousnessIsIncoherentComponents from "./ai-consciousness-is-incoherent/article-components";
import "./ai-consciousness-is-incoherent/ai-consciousness-article.css";
import BuildingAnLlmContent from "./building-an-llm/article.mdx";
import BuildingAnLlmAssets from "./building-an-llm/article-assets";
import BuildingAnLlmComponents from "./building-an-llm/article-components";
import ConsciousnessIsIncoherentContent from "./consciousness-is-incoherent/article.mdx";
import ConsciousnessIsIncoherentAssets from "./consciousness-is-incoherent/article-assets";
import ConsciousnessIsIncoherentComponents from "./consciousness-is-incoherent/article-components";
import TheCognitiveFactoryContent from "./the-cognitive-factory/article.mdx";
import TheCognitiveFactoryAssets from "./the-cognitive-factory/article-assets";
import TheCognitiveFactoryComponents from "./the-cognitive-factory/article-components";
import TheKnowledgeFactoryContent from "./the-knowledge-factory/article.mdx";
import TheKnowledgeFactoryAssets from "./the-knowledge-factory/article-assets";
import TheKnowledgeFactoryComponents from "./the-knowledge-factory/article-components";
import TheOntologyFactoryContent from "./the-ontology-factory/article.mdx";
import TheOntologyFactoryAssets from "./the-ontology-factory/article-assets";
import TheOntologyFactoryComponents from "./the-ontology-factory/article-components";
import "./the-ontology-factory/ontology-figures.css";
import TruthAndInferenceContent from "./truth-and-inference/article.mdx";
import TruthAndInferenceAssets from "./truth-and-inference/article-assets";
import TruthAndInferenceComponents from "./truth-and-inference/article-components";
import "./truth-and-inference/truth-instruments.css";
import UnderstandingAndBottlenecksContent from "./understanding-and-bottlenecks/article.mdx";
import UnderstandingAndBottlenecksAssets from "./understanding-and-bottlenecks/article-assets";
import UnderstandingAndBottlenecksComponents from "./understanding-and-bottlenecks/article-components";
import "./understanding-and-bottlenecks/neural-inference-figure.css";
import "./understanding-and-bottlenecks/understanding-figures.css";
import VisionAndValuesContent from "./vision-and-values/article.mdx";
import VisionAndValuesAssets from "./vision-and-values/article-assets";
import VisionAndValuesComponents from "./vision-and-values/article-components";
import "./vision-and-values/goals-article.css";

export interface GeneratedBlogArticle {
  Content: ComponentType<MDXProps>;
  assets: ArticleAssetRegistry;
  createComponents?: (context: ArticleRenderContext) => Record<string, ComponentType<never>>;
}

export const blogArticles: Record<string, GeneratedBlogArticle> = {
  "conspiracy-by-categories": { Content: ConspiracyByCategoriesContent, assets: ConspiracyByCategoriesAssets },
  "ai-consciousness-is-incoherent": { Content: AiConsciousnessIsIncoherentContent, assets: AiConsciousnessIsIncoherentAssets, createComponents: AiConsciousnessIsIncoherentComponents },
  "building-an-llm": { Content: BuildingAnLlmContent, assets: BuildingAnLlmAssets, createComponents: BuildingAnLlmComponents },
  "consciousness-is-incoherent": { Content: ConsciousnessIsIncoherentContent, assets: ConsciousnessIsIncoherentAssets, createComponents: ConsciousnessIsIncoherentComponents },
  "the-cognitive-factory": { Content: TheCognitiveFactoryContent, assets: TheCognitiveFactoryAssets, createComponents: TheCognitiveFactoryComponents },
  "the-knowledge-factory": { Content: TheKnowledgeFactoryContent, assets: TheKnowledgeFactoryAssets, createComponents: TheKnowledgeFactoryComponents },
  "the-ontology-factory": { Content: TheOntologyFactoryContent, assets: TheOntologyFactoryAssets, createComponents: TheOntologyFactoryComponents },
  "truth-and-inference": { Content: TruthAndInferenceContent, assets: TruthAndInferenceAssets, createComponents: TruthAndInferenceComponents },
  "understanding-and-bottlenecks": { Content: UnderstandingAndBottlenecksContent, assets: UnderstandingAndBottlenecksAssets, createComponents: UnderstandingAndBottlenecksComponents },
  "vision-and-values": { Content: VisionAndValuesContent, assets: VisionAndValuesAssets, createComponents: VisionAndValuesComponents },
};
